import { Injectable } from '@angular/core';
import { MenuService as WebMenuService, MenuItem } from '@foo/foo-web-framework';

@Injectable({
  providedIn: 'root'
})
export class LayoutMenuService extends WebMenuService {

  override getMenuItems(): MenuItem[] {
    return [
      {
        title: 'landing_home',
        icon: 'foo-menu-home-dt-neutral-dark',
        path: '/home'
      },
      {
        title: 'wallet_qr_payments_title',
        icon: 'foo-menu-scan-pay-dt-neutral-dark',
        path: '/qr-payments'
      },
      {
        title: 'more_title',
        icon: 'foo-menu-more-dt-neutral-dark',
        path: '/more'
      }
    ];
  }
}
